import { AllergyForm } from "~/components/form/health-profile/AllergyForm";
import { Authorize } from "~/components/permission/Authorize";
import { useDismiss } from "~/providers/DismissProvider";

export default function CreateAllergy() {
    const { handleDismiss } = useDismiss();

    return (
        <Authorize ability="update" section="allergies">
            <AllergyForm onRequestClose={handleDismiss} asRoute />
        </Authorize>
    );
}
